import { useContext } from 'react';

import { Box, Typography } from '@material-ui/core';
import { useDrop } from 'react-dnd';

import { ItemTypes } from '../config';
import { FieldsValuesContext } from './FieldsValuesContext';
import { Field } from './Field';

export const TimeLogsDetailBlock = () => {
  const [, drop] = useDrop(() => ({ accept: ItemTypes.TIME }));
  const { timeLogFields } = useContext(FieldsValuesContext);

  return (
    <div ref={drop}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle2">
          Select & order the columns you want in your Custom Time Log Export:
        </Typography>
      </Box>
      <Box display="flex" flexDirection="column" gridGap={8}>
        {timeLogFields.map(item => (
          <Field key={item.id} {...item} fieldType={ItemTypes.TIME} />
        ))}
      </Box>
    </div>
  );
};
